import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import ComponentTemplate from "../../../Utilities/TemplateWrappers/ComponentTemplate";

import {
    Table,
    TableRow,
    TableHead,
    TableCell,
    TableBody,
    IconButton,
} from "@material-ui/core";

import {
    getJobPack,
    getReportTitles,
    getRegisteredUsers,
    setReport,
    getReciepts,
} from "./actions";
import { Edit as EditIcon, RemoveRedEye as ViewIcon } from "@material-ui/icons";

class RelatedReports extends Component {
    constructor(props) {
        super(props);
        this.state = {
            new_group: {
                users_in_group: "",
            },
        };
        props.getReportTitles();
        props.getJobPack(props.uid, props.st, props.year, props.month);
        props.getRegisteredUsers();
    }

    render() {
        const { reports, reportTitles, reportPermissions } = this.props;

        return (
            <ComponentTemplate
                isCollapsed={false}
                isCollapsable={true}
                label="Submitted Reports"
            >
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableHeadCell text="Timestamp" />
                            <TableHeadCell text="User Name" />
                            <TableHeadCell text="Report Type" />
                            <TableHeadCell text="Actions" />
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {reports &&
                            reports.map((e, i) => {
                                let canUpdate = reportPermissions
                                    ? reportPermissions[e.report_type].update
                                    : true;

                                let canRead = reportPermissions
                                    ? reportPermissions[e.report_type].read
                                    : true;

                                return (
                                    <TableRow key={i}>
                                        <TableBodyCell text={e.timestamp} />
                                        <TableBodyCell text={e.user_name} />
                                        <TableBodyCell
                                            text={reportTitles[e.report_type]}
                                        />
                                        <TableCell>
                                            {canRead && (
                                                <Link
                                                    to={`/report-view/jobpacks/${
                                                        this.props.st
                                                    }/${this.props.year}/${
                                                        this.props.month
                                                    }/${
                                                        this.props.uid
                                                    }/${e.report_type.replace(
                                                        /_/g,
                                                        "-"
                                                    )}/${e.timestamp
                                                        .replace(/ /g, "_")
                                                        .replace(/:/g, ".")}`}
                                                >
                                                    <IconButton
                                                        style={{
                                                            color: "indigo",
                                                            border:
                                                                "1px solid indigo",
                                                            marginRight: 10,
                                                        }}
                                                    >
                                                        <ViewIcon />
                                                    </IconButton>
                                                </Link>
                                            )}
                                            {e.report_type ===
                                            "incident_and_accident"
                                                ? ""
                                                : e.report_type ===
                                                  "plant_equipment_examination_report"
                                                ? ""
                                                : e.report_type ===
                                                  "custom_report"
                                                ? ""
                                                : e.report_type ===
                                                  "daily_weekly_tractor_inspection"
                                                ? ""
                                                : e.report_type ===
                                                  "daily_weekly_roller_inspection"
                                                ? ""
                                                : e.report_type ===
                                                  "daily_weekly_mewp_inspection"
                                                ? ""
                                                : e.report_type ===
                                                  "daily_weekly_dumper_inspection"
                                                ? ""
                                                : e.report_type ===
                                                  "daily_weekly_excavator_inspection"
                                                ? ""
                                                : e.report_type ===
                                                  "tm_slg_checklist"
                                                ? ""
                                                : e.report_type ===
                                                  "jcenviro_ppe_inspection"
                                                ? ""
                                                : e.report_type ===
                                                  "jcenviro_confined_space"
                                                ? ""
                                                : e.report_type ===
                                                  "jcenviro_vehicle_checklist"
                                                ? ""
                                                : e.report_type ===
                                                  "master_sswp_v2"
                                                ? ""
                                                : e.report_type === "tm_plan"
                                                ? ""
                                                : e.report_type ===
                                                  "garda_notification_report"
                                                ? ""
                                                : e.report_type ===
                                                  "covid_daily_safe_start"
                                                ? ""
                                                : e.report_type ===
                                                  "covid_return_to_work"
                                                ? ""
                                                : canUpdate && (
                                                      <Link
                                                          to={`/report-edit-jobpack/jobpacks/${
                                                              this.props.st
                                                          }/${
                                                              this.props.year
                                                          }/${
                                                              this.props.month
                                                          }/${
                                                              this.props.uid
                                                          }/${e.report_type.replace(
                                                              /_/g,
                                                              "-"
                                                          )}/${e.timestamp
                                                              .replace(
                                                                  / /g,
                                                                  "_"
                                                              )
                                                              .replace(
                                                                  /:/g,
                                                                  "."
                                                              )}`}
                                                      >
                                                          <IconButton
                                                              style={{
                                                                  color:
                                                                      "indigo",
                                                                  border:
                                                                      "1px solid indigo",
                                                                  marginRight: 10,
                                                              }}
                                                          >
                                                              <EditIcon />
                                                          </IconButton>
                                                      </Link>
                                                  )}
                                        </TableCell>
                                    </TableRow>
                                );
                            })}
                    </TableBody>
                </Table>
            </ComponentTemplate>
        );
    }
}

const TableHeadCell = (props) => {
    return (
        <TableCell>
            <b>{props.text}</b>
        </TableCell>
    );
};
const TableBodyCell = (props) => {
    return (
        <TableCell>{props.text === undefined ? "N/A" : props.text}</TableCell>
    );
};
export default connect(
    (store, props) => {
        const { selectors } = props;
        const {
            selectJobpack,
            selectReports,
            selectReportTitles,
            selectRegisteredUsers,
            selectRecieptsData,
        } = selectors;
        return {
            jobPack: selectJobpack(store),
            reports: selectReports(store),
            reportTitles: selectReportTitles(store),
            users: selectRegisteredUsers(store),
            //   jobpackReports: selectJobpackReports(store),
            receiptsData: selectRecieptsData(store),
        };
    },
    { getJobPack, getReportTitles, getRegisteredUsers, setReport, getReciepts }
)(RelatedReports);
